export const operatingSystems = {
    aws: [
        {
            name: 'Microsoft Windows Server 2019 Base',
            ami: 'resolve:ssm:/aws/service/marketplace/prod-6ix65zcbm2vfo/latest',
        },
        {
            name: 'Microsoft Windows Server 2016 Base',
            ami: 'resolve:ssm:/aws/service/marketplace/prod-4rnzi4tajkxzu/latest',
        },
    ],
    gcp: [
        {
            name: 'Microsoft Windows Server 2019 Base',
            ami: 'projects/windows-cloud/global/images/family/windows-2019',
        },
        {
            name: 'Microsoft Windows Server 2016 Base',
            ami: 'projects/windows-cloud/global/images/family/windows-2016',
        },
    ]
}